import { render, staticRenderFns } from "./SupplierDetailsTab.vue?vue&type=template&id=38cbd9fc&scoped=true"
import script from "./SupplierDetailsTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./SupplierDetailsTab.vue?vue&type=style&index=0&id=38cbd9fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cbd9fc",
  null
  
)

export default component.exports